import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services/api.service';
import { GetConfigParams, GetConfigResponse, UpdateConfigParams, UpdateConfigResponse } from '../dtos';

@Injectable({
  providedIn: 'root',
})
export class ConfiguratorService {
  constructor(private readonly apiService: ApiService) {}

  getConfig(getConfigParams: GetConfigParams): Observable<GetConfigResponse> {
    return this.apiService.get(
      `/v1/configs/${getConfigParams.namespace}/${getConfigParams.owner}`
    );
  }

  updateConfig(updateConfigParams: UpdateConfigParams): Observable<UpdateConfigResponse> {
    return this.apiService.put(
      `/v1/configs/${updateConfigParams.namespace}/${updateConfigParams.owner}`,
      updateConfigParams,
    );
  }
}
